"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLocalDateToBookingDate = transformLocalDateToBookingDate;
const utcToZonedTimeOrDefault_1 = require("../helpers/utcToZonedTimeOrDefault");
function transformLocalDateToBookingDate(localDate, timezone) {
    const departureUTC = Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), localDate.getHours(), localDate.getMinutes());
    return (0, utcToZonedTimeOrDefault_1.utcToZonedTimeOrDefault)(departureUTC, timezone);
}
//# sourceMappingURL=transformLocalDateToBookingDate.js.map